// extracted by mini-css-extract-plugin
export default {"root":"role_information-module___root___f8637deb","body":"role_information-module___body___b932f293","skillsTitle":"role_information-module___skillsTitle___aa2f724b"};